import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { NgxsModule } from '@ngxs/store';

import { DropDownModule } from '@bayclubs/drop-down';

import { SharedModule } from '@shared/shared.module';

import { SpinnerModule } from '@bayclubs/spinner';
import { BayclubsUiCoreModule, TimeDisplayPipe } from '@bayclubs/ui-core';
import { BayclubsUiDatePickerModule } from '@bayclubs/ui-date-picker';
import { CourtBookingSaveState } from './+store/court-booking-save.state';
import { CourtBookingPlayerInfoComponent } from './components/court-booking-player-info/court-booking-player-info.component';
import { TimeSlotsSelectComponent } from './components/time-slots-select/time-slots-select.component';
import { CourtBookingPlayerSearchComponent } from './containers/court-booking-player-search/court-booking-player-search.component';
import { CourtBookingSaveDetailsComponent } from './containers/court-booking-save-details/court-booking-save-details.component';
import { CourtBookingSaveModalComponent } from './containers/court-booking-save-modal/court-booking-save-modal.component';
import { CourtBookingSavePlayerAddNewComponent } from './containers/court-booking-save-player-add-new/court-booking-save-player-add-new.component';
import { CourtBookingSavePlayerAddComponent } from './containers/court-booking-save-player-add/court-booking-save-player-add.component';
import { CourtBookingSavePlayerSearchComponent } from './containers/court-booking-save-player-search/court-booking-save-player-search.component';
import { CourtBookingSavePlayersComponent } from './containers/court-booking-save-players/court-booking-save-players.component';

@NgModule({
    declarations: [
        CourtBookingSaveModalComponent,
        CourtBookingPlayerSearchComponent,
        CourtBookingPlayerInfoComponent,
        CourtBookingSaveDetailsComponent,
        TimeSlotsSelectComponent,
        CourtBookingSavePlayersComponent,
        CourtBookingSavePlayerAddComponent,
        CourtBookingSavePlayerSearchComponent,
        CourtBookingSavePlayerAddNewComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgxsModule.forFeature([CourtBookingSaveState]),
        NgxsFormPluginModule,
        DropDownModule,
        TranslateModule,
        SharedModule,
        BayclubsUiCoreModule,
        BayclubsUiDatePickerModule,
        SpinnerModule
    ],
    providers: [
        TimeDisplayPipe
    ]
})
export class CourtBookingSaveModule { }

export * from './+store/court-booking-save.actions';
export * from './models/court-booking-save-input.model';
export * from './services/court-booking-save-launcher.service';

